module.exports = __webpack_public_path__ + "static/media/unionpay.c01ae791.svg";